import { PurchaseData } from 'coaching/experiment/SignInFunnelExperiment';
import moment from 'moment-timezone';

export const EXPERIMENT_DATA_KEY = 'signInExperimentData';

export type ExperimentInfo = {
  purchaseData?: PurchaseData;
  experimentEnabled: boolean;
};

export function saveExperimentInfo(newData: ExperimentInfo | null) {
  const storage = window?.sessionStorage;
  if (newData !== null) {
    storage?.setItem(EXPERIMENT_DATA_KEY, JSON.stringify(newData));
  } else {
    storage?.removeItem(EXPERIMENT_DATA_KEY);
  }
}

export function getStoredExperimentInfo(): ExperimentInfo | null {
  try {
    const stringifiedData = window?.sessionStorage?.getItem(EXPERIMENT_DATA_KEY);
    let experimentData;
    experimentData = stringifiedData && JSON.parse(stringifiedData);
    if (experimentData.purchaseData) {
      const selectedReservation = experimentData.purchaseData.selectedReservation;
      selectedReservation.startDateTime = moment(selectedReservation.startDateTime);
      selectedReservation.endDateTime = moment(selectedReservation.endDateTime);
    }

    return experimentData;
  } catch {
    return null;
  }
}
